<div class="static-file-manager-body">
  <router-outlet></router-outlet>
</div>
